import { useEffect, useMemo, useState} from "react";
import CompleteLogModal from "../../../components/modals/CompleteLogModal.jsx"
import AddPhoneCall from "../../../components/modals/AddPhoneCall.jsx";
import PhoneLoggerModal from "../../../components/modals/phonelogger/[id].jsx";
import useLookupStore from "../../../states/useLookupStore";
import useDealStore from "../../../states/useDealStore";
import ExpandableNote from "./ExpandableNote";

function formatCallDate(value) {
    if (!value) {
        return "-";
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }

    return date.toLocaleString([], {
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
    });
}

function CallsTab({ contactId, calls = [], callsLoading = false, callsError = "", onRefreshTabData, onComposeEmail, panelActionRequest, onPanelActionHandled }) {
    const [isAddCallOpen, setIsAddCallOpen] = useState(false);
    const [isCompleteLogOpen, setIsCompleteLogOpen] = useState(false);
    const [selectedCall, setSelectedCall] = useState(null);
    const contacts = useLookupStore((state) => state.contacts);
    const deals = useDealStore((state) => state.deals);
    const hydrateLookups = useLookupStore((state) => state.hydrateLookups);
    const hydrateDeals = useDealStore((state) => state.hydrateDeals);


    useEffect(() => {
        hydrateLookups();
    }, [hydrateLookups]);

    useEffect(() => {
        hydrateDeals();
    }, [hydrateDeals]);

    useEffect(() => {
        if (panelActionRequest?.type === "Log Call")
        {
            setIsAddCallOpen(true);
            onPanelActionHandled?.();
        }

    }, [panelActionRequest, onPanelActionHandled]);


    
    

    const selectedContact = useMemo(() => {
        const id = Number.parseInt(String(contactId || "0"), 10);
        if (!id) {
            return null;
        }
        return Array.isArray(contacts) ? contacts.find((contact) => Number(contact.id) === id) || null : null;
    }, [contactId, contacts]);

    return (
        <section className="tab-panel-container" aria-label="Call logs">
            <div className="tab-panel-header">
                <div>
                    <h3>Call Logs</h3>
                    <p className="tab-panel-subtitle">
                        • {calls.length} Log{calls.length === 1 ? "" : "s"}
                    </p>
                </div>
                <div className="tab-panel-actions">
                    <button
                        type="button"
                        className="tab-panel-btn tab-panel-btn--primary"
                        onClick={() => {
                            console.log("Log Call button clicked");
                            setIsAddCallOpen(true)
                        }}
                    >
                        Log Call +
                    </button>
                </div>
            </div>

            <table className="tab-panel-table">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Type</th>
                        <th>Direction</th>
                        <th>User</th>
                        <th>Deal</th>
                        <th>Duration</th>
                        <th>Notes</th>
                    </tr>
                </thead>
                <tbody>
                    {callsLoading ? (
                        <tr>
                            <td colSpan={7} className="tab-panel-empty">Loading call logs...</td>
                        </tr>
                    ) : callsError ? (
                        <tr>
                            <td colSpan={7} className="tab-panel-empty">{callsError}</td>
                        </tr>
                    ) : calls.length === 0 ? (
                        <tr>
                            <td colSpan={7} className="tab-panel-empty">No Calls data yet.</td>
                        </tr>
                    ) : (
                        calls.map((call) => (
                            <tr
                                key={String(call.id)}
                                className="tab-panel-row-clickable"
                                role="button"
                                tabIndex={0}
                                onClick={() => setSelectedCall(call)}
                                onKeyDown={(event) => {
                                    if (event.key === "Enter" || event.key === " ") {
                                        event.preventDefault();
                                        setSelectedCall(call);
                                    }
                                }}
                            >
                                <td>{formatCallDate(call.call_at)}</td>
                                <td>{String(call.call_type || "call").toUpperCase()}</td>
                                <td>{String(call.direction || "outbound").toUpperCase()}</td>
                                <td>{call.user_name || "Unknown user"}</td>
                                <td>{call.deal_title || "No deal linked"}</td>
                                <td>{Math.max(Number(call.duration_seconds) || 0, 0)}s</td>
                                <td><ExpandableNote>{call.notes}</ExpandableNote></td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>

            

            <PhoneLoggerModal
                isOpen={Boolean(selectedCall)}
                phoneCall={selectedCall}
                onClose={() => setSelectedCall(null)}
                onSaved={() => {
                    setSelectedCall(null);
                    onRefreshTabData?.();
                }}
            />

            <AddPhoneCall
                isOpen={isAddCallOpen}
                contacts={selectedContact ? [selectedContact] : []}
                deals={deals}
                onClose={() => {
                    setIsAddCallOpen(false);                }}
                onCreated={() => {
                    setIsAddCallOpen(false);
                    setIsCompleteLogOpen(true);
                    onRefreshTabData?.();
                }}
            />

            <CompleteLogModal
                isOpen={isCompleteLogOpen}
                onClose={() => setIsCompleteLogOpen(false)}
                onProceed={() => {
                    setIsCompleteLogOpen(false);
                    onRefreshTabData?.();
                }}
                onComposeEmail={onComposeEmail}
            />
        </section>
    );

}

export default CallsTab;
